<template>
  <div class="unscheduled-respondent-form">
		<v-card class="card-create-respondents" outlined>
      <v-card-title><h1 class="h5 font-weight-regular">Create New Respondent Wizard</h1></v-card-title>
			<v-stepper
				v-model="e2"
				vertical
				ref="stepper"
			>
				<!-- STEP 1 -->
				<foe-stepper-step
					:complete="e2 > 1"
					:editable="e2 > 1"
					step="1"
					tabIndex="0"
					v-on:stepper-enter="handleStepperEnter"
					v-on:stepper-back="handleStepperBack"
					color="#B85623"
					class="respondentWizardStepper"
					role="button"
					aria-controls="steppercontent-1"
					:aria-expanded="convertToString(openContent1)"
					v-on:click="clickStepHeader(1)"
				>
					<h2 v-if="e2===1" class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOn" >Starting IDNumber: {{startingNum}} ({{selectedStudy.studyId}}{{startingNum}})</h2>
					<h2 v-else class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOff">Starting IDNumber: {{startingNum}} ({{selectedStudy.studyId}}{{startingNum}})</h2>
				</foe-stepper-step>
				<v-stepper-content step="1" id="steppercontent-1" :aria-disabled="!openContent1">
					<v-form
						ref="form1"
						v-model="valid"
						lazy-validation
						:class="{ 'd-block': openContent1, 'd-none': !openContent1}"
					>
						<v-row>
							<v-col
								:cols="2"
							>
								<p class="p2 left-align"><label for="form-starting-number">Identify the starting ID Number</label></p>
							</v-col>
							<v-col
								:cols="2"
							>
								<v-text-field
									v-model="startingNum"
									hide-details="auto"
									outlined
									id="form-starting-number"
									:rules="IDNumberRules"
									type="number"
									min="0"
									ref="firstFocusable"
								></v-text-field>
							</v-col>
							<v-col
								:cols="2"
							>
								{{selectedStudy.studyId}}{{startingNum}}
							</v-col>
							<v-col
								:cols="6"
							>
								<div class="sidebar-callout">
									<p class="p2 expl">Respondent usernames are comprised of the study abbreviation ({{selectedStudy.studyId}}) and an ID number.
										The wizard will use the starting ID number and create a range of unique usernames. You will specify the number of
										usernames to create in a subsequent step.
										<br><br>
										For example, if you specify 101, the first username will be {{selectedStudy.studyId}}101.
									</p>
								</div>
							</v-col>
						</v-row>
						<v-divider inset></v-divider>
						<v-card-actions>
							<v-btn text class="btn-default" @click="onOpenCancel()">Cancel</v-btn>
							<v-spacer></v-spacer>
							<v-btn text class="btn-default" @click="onOpenCancel()">&lt; Back</v-btn>
							<v-btn
								:loading="loadingSave"
								text
								class="btn-default"
								@click="check(1)"
							>
								Next >
							</v-btn>
						</v-card-actions>
					</v-form>
				</v-stepper-content>
				<!-- STEP 2 -->
				<foe-stepper-step
					:complete="e2 > 2"
					:editable="e2 > 2"
					step="2"
					tabIndex="0"
					v-on:stepper-enter="handleStepperEnter"
					v-on:stepper-back="handleStepperBack"
					color="#B85623"
					class="respondentWizardStepper"
					role="button"
					aria-controls="steppercontent-2"
					:aria-expanded="convertToString(openContent2)"
					v-on:click="clickStepHeader(2)"
				>
				<h2 v-if="e2===2" class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOn" >Number of respondents to create: {{respondentNum}}</h2>
					<h2 v-else class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOff">Number of respondents to create: {{respondentNum}}</h2>
				</foe-stepper-step>
				<v-stepper-content step="2" :aria-disabled="!openContent2">
					<v-form
						ref="form2"
						v-model="valid"
						lazy-validation
						:class="{ 'd-block': openContent2, 'd-none': !openContent2}"
					>
						<v-row>
							<v-col
								:cols="2"
							>
								<p class="p2 left-align"><label for="form-respondent-number">Number of Respondents:</label></p>
							</v-col>
							<v-col
								:cols="2"
							>
								<v-text-field
									v-model="respondentNum"
									hide-details="auto"
									outlined
									id="form-respondent-number"
									:rules="IDNumberRules"
									type="number"
									min="0"
								></v-text-field>
							</v-col>
							<v-col
								:cols="2"
							>
							</v-col>
							<v-col
								:cols="6"
							>
								<div class="sidebar-callout">
									<p class="p2 expl">
										Specify the number of respondent usernames to be created.
										You can add more usernames later, as needed.
									</p>
								</div>
							</v-col>
						</v-row>
						<v-divider inset></v-divider>
						<v-card-actions>
							<v-btn text class="btn-default" @click="onOpenCancel()">Cancel</v-btn>
							<v-spacer></v-spacer>
							<v-btn text class="btn-default" @click="e2--">&lt; Back</v-btn>
							<v-btn
								text
								class="btn-default"
								@click="check(2)"
							>
								Next >
							</v-btn>
						</v-card-actions>
					</v-form>
				</v-stepper-content>
				<!-- STEP 3 -->
				<foe-stepper-step
					:complete="e2 > 3"
					:editable="e2 > 3"
					step="3"
					tabIndex="0"
					v-on:stepper-enter="handleStepperEnter"
					v-on:stepper-back="handleStepperBack"
					color="#B85623"
					class="respondentWizardStepper"
					role="button"
					aria-controls="steppercontent-3"
					:aria-expanded="convertToString(openContent3)"
					v-on:click="clickStepHeader(3)"
				>
				<h2 v-if="e2===3" class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOn" >Number of recalls per respondent: {{recallsRespondentNum}}</h2>
					<h2 v-else class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOff">Number of recalls per respondent: {{recallsRespondentNum}}</h2>
				</foe-stepper-step>
				<v-stepper-content step="3" :aria-disabled="!openContent3">
					<v-form
						ref="form3"
						v-model="valid"
						lazy-validation
						:class="{ 'd-block': openContent3, 'd-none': !openContent3}"
					>
						<v-row>
							<v-col
								:cols="2"
							>
								<p class="p2 left-align"><label for="form-recalls-number">Number of recalls per respondent</label></p>
							</v-col>
							<v-col
								:cols="2"
							>
								<v-text-field
									v-model="recallsRespondentNum"
									hide-details="auto"
									outlined
									id="form-recalls-number"
									:rules="IDNumberRules"
									type="number"
									min="0"
								></v-text-field>
							</v-col>
							<v-col
								:cols="2"
							>
							</v-col>
							<v-col
								:cols="6"
							>
								<div class="sidebar-callout">
									<p class="p2 expl">
										The default number of recalls to be completed by each respondent is the number you provided when you created the study.
										You can change the number of recalls per respondent here, if necessary. Note: In a later step, you will be asked to specify
										the number of attempts allowed for each recall.
									</p>
								</div>
							</v-col>
						</v-row>
						<v-divider inset></v-divider>
						<v-card-actions>
							<v-btn text class="btn-default" @click="onOpenCancel()">Cancel</v-btn>
							<v-spacer></v-spacer>
							<v-btn text class="btn-default" @click="e2--">&lt; Back</v-btn>
							<v-btn
								text
								class="btn-default"
								@click="check(3)"
							>
								Next >
							</v-btn>
						</v-card-actions>
					</v-form>
				</v-stepper-content>
				<!-- STEP 4 -->
				<foe-stepper-step
					:complete="e2 > 4"
					:editable="e2 > 4"
					step="4"
					tabIndex="0"
					v-on:stepper-enter="handleStepperEnter"
					v-on:stepper-back="handleStepperBack"
					color="#B85623"
					class="respondentWizardStepper"
					role="button"
					aria-controls="steppercontent-4"
					:aria-expanded="convertToString(openContent4)"
					v-on:click="clickStepHeader(4)"
				>
				<h2 v-if="e2===4" class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOn" >Account Passwords</h2>
					<h2 v-else class="subtitle-1 font-weight-regular respondentWizardStepperHeaderOff">Account Passwords</h2>
				</foe-stepper-step>
				<v-stepper-content step="4" :aria-disabled="!openContent4">
					<v-form
						ref="form4"
						v-model="valid"
						lazy-validation
						:class="{ 'd-block': openContent4, 'd-none': !openContent4}"
					>
						<v-row>
							<v-col
								:cols="6"
							>
								<v-row>
									<v-col
										:cols="4"
									>
										<p class="p2 left-align">Setting account passwords</p>
									</v-col>
									<v-col :cols="8">

										<fieldset class="border-0">
											<legend class="d-sr-only">
												Setting account passwords
											</legend>

											<v-radio-group v-model="passwordSelection"
																		 :rules="radioRules"
																		 id="form-password-option">
												<v-radio v-for="(passwordOption, i) in this.$respondentsWizardLists.passwordOptions"
																 :key="passwordOption.value + i"
																 :label="passwordOption.displayText"
																 :value="passwordOption.value"></v-radio>
											</v-radio-group>

										</fieldset>

									</v-col>
								</v-row>
								<v-row
									v-if="passwordSelection === this.$respondentsWizardLists.passwordOptions[0].value"
								>
									<v-col
										:cols="4"
									>
										<p class="p2 left-align"><label for="form-password-root">Root word:</label></p>
									</v-col>
									<v-col
										:cols="8"
									>
										<v-text-field
											v-model="passwordRoot"
											hide-details="auto"
											outlined
											id="form-password-root"
											:rules="passwordRootRules"
										></v-text-field>
									</v-col>
								</v-row>
							</v-col>
							<v-col
								:cols="6"
							>
								<div class="sidebar-callout">
									<p class="p2 expl">
										There are two options for password creation. A root word (e.g., Pizzas) can
										be specified and the system will generate random extensions to create secure passwords
										(e.g., Pizzas&amp;556). This root word must contain only alphanumeric characters and must
										be between four and six characters in length.
										<br><br>
										Alternatively, the system can generate random secure passwords (e.g. blaCKhaWk421!).
									</p>
								</div>
							</v-col>
						</v-row>
						<v-divider inset></v-divider>
						<v-card-actions>
							<v-btn text class="btn-default" @click="onOpenCancel()">Cancel</v-btn>
							<v-spacer></v-spacer>
							<v-btn text class="btn-default" @click="e2--">&lt; Back</v-btn>
							<v-btn
								text
								class="btn-default"
								@click="check(4, true)"
								:loading="submitBtnLoading"
							>
								Create Respondents
							</v-btn>
						</v-card-actions>
					</v-form>
				</v-stepper-content>
			</v-stepper>
    </v-card>
	</div>
</template>

<script>
import { researcherApiService } from '@/services/researcherApiService';

export default {
	name: 'UnscheduledRespondentForm',
	props: {
	},
	data: () => ({
		loadingSave: false,
		submitBtnLoading: false,
		valid: true,
		e2: 1,
		startingNum: '',
		respondentNum: '',
		recallsRespondentNum: '',
		passwordSelection: '',
		passwordRoot: '',
		IDNumberRules: [v => v !== '' || 'This section is required'],
		radioRules: [v => v !== '' || 'This section is required'],
		passwordRootRules: [
			v => v !== '' || 'This section is required',
			v => (v && v.length > 3) || 'The password root must be between 4-6 characters',
			v => (v && v.length < 7) || 'The password root must be between 4-6 characters'
		],
		openContent1: true, // true or false for whether Content 1 is opened.
		openContent2: false,
		openContent3: false,
		openContent4: false
	}),
	mounted () {
		this.recallsRespondentNum = this.selectedStudy.numRecallsPerParticipant;

		this.$nextTick(function () {
			var vRadioGroup = document.getElementsByClassName('v-input--radio-group__input');
			for (var i = 0; i < vRadioGroup.length; i++) {
				vRadioGroup[i].removeAttribute('aria-labelledby');
			}
		});
		var myFirstElement = this.$refs.firstFocusable
		myFirstElement.focus();
	},
	watch: {
		e2: function (newVal, oldVal) {
			if (newVal === 1) {
				this.openContent1 = true
				this.openContent2 = false
				this.openContent3 = false
				this.openContent4 = false
			}
			if (newVal === 2) {
				this.openContent1 = false
				this.openContent2 = true
				this.openContent3 = false
				this.openContent4 = false
			}
			if (newVal === 3) {
				this.openContent1 = false
				this.openContent2 = false
				this.openContent3 = true
				this.openContent4 = false
			}
			if (newVal === 4) {
				this.openContent1 = false
				this.openContent2 = false
				this.openContent3 = false
				this.openContent4 = true
			}
		}
	},
	methods: {
		onOpenCancel () {
			this.$emit('cancel');
		},
		check (formNumber, lastStep = false) {
			var valid = false;
			switch (formNumber) {
			case 1:
				valid = this.$refs.form1.validate();
				break;
			case 2:
				valid = this.$refs.form2.validate();
				break;
			case 3:
				valid = this.$refs.form3.validate();
				break;
			case 4:
				valid = this.$refs.form4.validate();
				break;
			}

			if (valid && lastStep) {
				this.createRespondents();
			} else if (valid) {
				this.e2++;
			}
		},
		createRespondents () {
			this.submitBtnLoading = true;
			const me = this;
			researcherApiService.wizardCreateRespondents(this.selectedStudy.studyUuid, this.respondentsInfo)
				.then(function (response) {
					if (response) {
						me.$router.push({ name: 'ConfirmationPage', params: { fileNameRespondents: response.data.fileNameRespondents } });
					}
					me.submitBtnLoading = false;
				})
				.catch(function (e) {
					console.log(e.response);
					me.submitBtnLoading = false;

					// 401 and 500 errors should not be displayed to the user
					if (status !== 401 && status !== 500) {
						var errorMessage = 'Error';
						if (e.response.data.messages) {
							errorMessage = e.response.data.messages[0]
						}
						me.$store.dispatch('changeUpdateStatusWithMessage', { status: 'wizard-error', message: errorMessage });
					}
				});
		},
		handleStepperEnter (args) {
			// Incoming args hold the stepper number. Update the binding variable with the value.
			// Only support this for going backwards. To move forwards the user must use the Next button.
			if (parseInt(args) < parseInt(this.e2)) {
				this.e2 = parseInt(args);
			}
		},
		/**
		 * Handles the stepper back tab event by changing the focus to the previous step header.
		 */
		handleStepperBack (args) {
			const isStepNotFirst = args.step > 1;
			// If we are moving back to the active step then tab through all controls in the step.
			const isNotMovingToActiveStep = (args.step - 1) !== parseInt(this.e2);
			if (isStepNotFirst && isNotMovingToActiveStep) {
				// If we are back tabbing to inactive steps, we need to set the focus to the previous step header.
				args.keyDownEvent.preventDefault();
				const steps = this.getStepperSteps();
				if (steps.length >= args.step) {
					steps[args.step - 2].$el.focus();
				}
			}
		},
		/**
		 * Gets all the StepperStepWrapper components that are children of the stepper ref.
		 */
		getStepperSteps () {
			return this.$refs.stepper.$children.filter(child => { return child.$options.name === 'StepperStepWrapper'; });
		},
		clickStepHeader (sNum) {
			if (parseInt(sNum) < parseInt(this.e2)) {
				this.e2 = parseInt(sNum);
			}
		},
		convertToString (text) {
			var stringText = text + ''
			return stringText
		}
	},
	computed: {
		selectedStudy: function () {
			// This computed property will update the study when the selected study is
			// modified in the store
			return this.$store.getters.getSelectedStudy;
		},
		respondentsInfo: function () {
			console.log('test1')
			var info = {
				startingIdNumber: this.startingNum,
				respondentCount: this.respondentNum,
				recallsPerRespondent: this.recallsRespondentNum,
				hasPasswordRoot: this.passwordSelection === this.$respondentsWizardLists.passwordOptions[0].value,
				passwordRoot: this.passwordRoot,
				studyUuid: this.selectedStudy.studyUuid,
				wizardType: this.$respondentsWizardLists.WIZARD_TYPE_UNSCHEDULED.value
			}
			return info;
		}
	}
}
</script>

<style>
</style>
